import React from "react";
import TextField from "./TextField";

type Field = {
  // básicos
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  options?: string[]; // se presente => TextField mostra dropdown
  style?: React.CSSProperties;

  // comportamentos extras (repasse 1:1 pro TextField)
  uppercase?: boolean;
  contabil?: boolean;
  locked?: boolean;
  disabled?: boolean;
  date?: boolean;
  numericWithUnit?: boolean;

  // Botão 1
  button?: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
  buttonWidth?: number | string;
  buttonDisabled?: boolean;
  buttonVariant?: "primary" | "secondary";

  // Botão 2
  secondButton?: boolean;
  secondButtonText?: string;
  onSecondButtonClick?: () => void;
  secondButtonWidth?: number | string;
  secondButtonDisabled?: boolean;
  secondButtonVariant?: "primary" | "secondary";
};

type TextFieldRowProps = {
  left?: Field;
  right?: Field;
  center?: Field; // se existir, ocupa a linha inteira
  gap?: number; // espaçamento horizontal entre colunas (px)
  marginLeft?: number; // deslocamento horizontal da linha
  minItemWidth?: number | string; // largura mínima dos itens
  wrap?: boolean; // se true, permite quebra de linha (default true)
};

const TextFieldRow: React.FC<TextFieldRowProps> = ({
  left,
  right,
  center,
  gap = 20,
  marginLeft = 0,
  minItemWidth = 250,
  wrap = true,
}) => {
  const baseWrapStyle: React.CSSProperties = {
    flex: 1,
    minWidth:
      typeof minItemWidth === "number" ? `${minItemWidth}px` : minItemWidth,
  };

  const rowBaseStyle: React.CSSProperties = {
    display: "flex",
    flexWrap: wrap ? "wrap" : "nowrap",
    gap: `${gap}px`,
    marginLeft: `${marginLeft}px`,
    marginTop: "0px",
    marginBottom: "0px",
    width: "100%",
  };

  const renderField = (f: Field) => {
    // Garante largura cheia dentro da célula
    const mergedStyle: React.CSSProperties = {
      width: "100%",
      ...(f.style || {}),
    };

    return (
      <div style={baseWrapStyle}>
        <TextField
          label={f.label}
          value={f.value}
          onChange={f.onChange}
          placeholder={f.placeholder}
          options={f.options}
          style={mergedStyle}
          uppercase={f.uppercase}
          contabil={f.contabil}
          locked={f.locked}
          disabled={f.disabled}
          date={f.date}
          numericWithUnit={f.numericWithUnit}
          // Botão 1
          button={f.button}
          buttonText={f.buttonText}
          onButtonClick={f.onButtonClick}
          buttonWidth={f.buttonWidth}
          buttonDisabled={f.buttonDisabled}
          buttonVariant={f.buttonVariant}
          // Botão 2
          secondButton={f.secondButton}
          secondButtonText={f.secondButtonText}
          onSecondButtonClick={f.onSecondButtonClick}
          secondButtonWidth={f.secondButtonWidth}
          secondButtonDisabled={f.secondButtonDisabled}
          secondButtonVariant={f.secondButtonVariant}
        />
      </div>
    );
  };

  // Se center estiver presente, renderiza sozinho ocupando a linha inteira
  if (center) {
    return <div style={rowBaseStyle}>{renderField(center)}</div>;
  }

  // Caso padrão: left e/ou right
  return (
    <div style={rowBaseStyle}>
      {left && renderField(left)}
      {right && renderField(right)}
    </div>
  );
};

export default TextFieldRow;
